/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import Icon from "react-icons-kit";
import { ic_add } from "react-icons-kit/md/ic_add";
import { ic_clear } from "react-icons-kit/md/ic_clear";
import styles from "./ComplicationMiniSelector.module.css";
import Button from "@ls/react-button";
import Checkbox from "@ls/react-checkbox";

const ComplicationMiniSelector = ({
  definitions,
  setDefinition,
  getDefaultDefinition,
  Complication,
  btnTitle,
  single,
  dispatch,
}) => {
  const hasComplications = definitions && definitions.length > 0;
  const onCheckComplicationButton = useCallback(() => {
    if (hasComplications) {
      if (single) {
        dispatch(setDefinition(0, null));
      } else {
        definitions.forEach((def, idx) => dispatch(setDefinition(idx, null)));
      }
    } else {
      dispatch(setDefinition(0, getDefaultDefinition()));
    }
  }, [
    hasComplications,
    setDefinition,
    getDefaultDefinition,
    single,
    dispatch,
    definitions,
  ]);
  return (
    <div className={styles.root}>
      <div className={styles.checkbox}>
        <Checkbox
          label={btnTitle}
          value={hasComplications}
          onChange={onCheckComplicationButton}
        />
      </div>
      {hasComplications && Complication && (
        <div className={styles.complications}>
          {definitions.map((definition, idx) => (
            <div className={styles.complicationRoot} key={idx}>
              <div className={styles.complication}>
                <Complication
                  definition={definition}
                  setDefinition={(definition) =>
                    dispatch(setDefinition(idx, definition))
                  }
                />
              </div>
              {!single && (
                <div className={styles.complicationDelete}>
                  <Button
                    onButtonClick={() => dispatch(setDefinition(idx, null))}
                    icon={
                      <Icon
                        icon={ic_clear}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#000",
                        }}
                      />
                    }
                    size="S"
                    variation={5}
                  />
                </div>
              )}
            </div>
          ))}
          {!single && (
            <div className={styles.addMoreBtn}>
              <Button
                onButtonClick={() =>
                  dispatch(
                    setDefinition(definitions.length, getDefaultDefinition())
                  )
                }
                icon={
                  <Icon
                    icon={ic_add}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#000",
                    }}
                  />
                }
                size="S"
                variation={5}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

ComplicationMiniSelector.propTypes = {
  definitions: PropTypes.array.isRequired,
  setDefinition: PropTypes.func.isRequired,
  getDefaultDefinition: PropTypes.func.isRequired,
  Complication: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  btnTitle: PropTypes.string,
  single: PropTypes.bool,
};

export default memo(ComplicationMiniSelector);
